
import { FaCheckCircle, FaBrain, FaGamepad, FaUserFriends } from "react-icons/fa";
import Navbar from "../Hero/Navbar/Navbar";
import Footer from "../Footer/Footer";
import Image from "../../assets/images/about.png";
import React, { useState, useEffect } from "react";
import aboutImage from "../../assets/QquzyNew.png";







const AboutPage = () => {
    const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0 }
      );
  
      const element = document.getElementById("about-section");
      if (element) {
        observer.observe(element);
      }
  
      return () => {
        if (element) {
          observer.unobserve(element);
        }
      };
    }, []);
  return (
    <>
      <Navbar />
      <section className="py-16 bg-white">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-gray-300 uppercase opacity-10 mb-2">
            ABOUT US
          </h2>
          <h3 className="text-4xl font-bold -mt-8 relative z-10 bg-gradient-to-r from-indigo-600 to-indigo-400 bg-clip-text text-transparent">
            ABOUT US
          </h3>
          <p className="text-gray-600 mt-2">
            QUZY is more than just a study app – it's a movement toward smarter, faster, and more engaging learning.
          </p>
        </div>

        {/* Main Feature Highlight - Similar to the image shown */}
        <div className="max-w-6xl mx-auto px-4 mb-16">
          <div className="bg-gradient-to-r from-indigo-600 to-indigo-400 text-white rounded-xl p-8 shadow-lg">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-4">Revolutionize Your Study Habits</h2>
                <p className="mb-6">
                  QUZY combines cutting-edge AI technology with proven learning methodologies to create a study experience that's not just effective, but actually enjoyable.
                </p>
                <ul className="space-y-2">
                  <li className="flex items-center">
                    <div className="bg-white bg-opacity-20 p-1 rounded-full mr-2">
                      <FaBrain className="text-white" />
                    </div>
                    <span>Adaptive learning that grows with you</span>
                  </li>
                  <li className="flex items-center">
                    <div className="bg-white bg-opacity-20 p-1 rounded-full mr-2">
                      <FaGamepad className="text-white" />
                    </div>
                    <span>Gamification that keeps you motivated</span>
                  </li>
                  <li className="flex items-center">
                    <div className="bg-white bg-opacity-20 p-1 rounded-full mr-2">
                      <FaUserFriends className="text-white" />
                    </div>
                    <span>Social learning that builds community</span>
                  </li>
                </ul>
              </div>
              <div className="flex justify-center">
                <div className="bg-white p-4 rounded-xl shadow-xl transform rotate-3 max-w-xs">
                  <div className="bg-indigo-100 p-2 rounded-lg">
                    <div className="text-center p-4">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 text-indigo-600 mx-auto mb-2">
                        <path d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75zM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 01-1.875-1.875V8.625zM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 013 19.875v-6.75z" />
                      </svg>
                      <h3 className="text-indigo-800 font-bold">AI-Powered</h3>
                      <p className="text-sm text-gray-600">Our intelligent system adapts to your unique learning style</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Left side - Mobile Phone with Image */}
          <div className="lg:w-2/5 relative">
            <div className="bg-indigo-100 absolute w-[350px] h-[350px] rounded-full opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></div>

            {/* Phone Frame with Image */}
            <div 
              className={`relative mx-auto transform transition-all duration-1000  'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`} 
              style={{ maxWidth: "280px" }}
            >
              <div className="relative border-8 border-indigo-100 rounded-[40px] shadow-xl overflow-hidden">
                {/* Notch */}
                <div className="absolute top-0 inset-x-0 h-6 bg-indigo-100 rounded-b-lg w-1/3 mx-auto z-10"></div>

                {/* Phone Screen with Image */}
                <div className="bg-white overflow-hidden" style={{ height: "500px" }}>
                  <img
                    src={aboutImage}
                    alt="QUZY App Interface"
                    className="w-full h-full object-contain"
                    style={{ objectPosition: 'center' }}
                  />
                </div>
              </div>

              {/* Phone Shadow */}
              <div className="absolute -bottom-4 inset-x-0 h-8 bg-gradient-to-t from-gray-900 to-transparent opacity-10 rounded-[40px] mx-auto" style={{ width: "90%" }}></div>
            </div>
          </div>

          {/* Right side - Content */}
          <div className="lg:w-3/5 mt-12 lg:mt-0 w-full">
            <div className={'transition-opacity duration-700 '}>
              <div className="bg-indigo-100 text-indigo-600 py-1 px-3 rounded-full text-sm font-medium inline-block mb-2">
                Our Mission
              </div>
              
              <h4 className="text-3xl font-bold text-indigo-600 mb-4">
                Built by Learners, for Learners
              </h4>
              
              <p className="text-gray-600 mb-6">
                At QUZY, we're reimagining how learning works in the digital age. With AI-powered tools, gamified quizzes, and a supportive community, we're turning revision into a rewarding experience.
              </p>

              <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
                <h5 className="font-bold text-gray-900 mb-4 text-lg">Why Choose QUZY?</h5>
                <ul className="space-y-4">
                  {[
                    {
                      title: "Personalized Learning",
                      desc: "Learning should adapt to you. QUZY personalizes your study path."
                    },
                    {
                      title: "Time Efficiency",
                      desc: "Time is precious – make every minute count with targeted revisions."
                    },
                    {
                      title: "Engaging Interface",
                      desc: "Smart doesn't mean boring. Our interface is fun, modern, and interactive."
                    },
                    {
                      title: "Collaborative Growth",
                      desc: "Learning is better together. Collaborate, challenge, and grow with your peers."
                    }
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start">
                      <div className="bg-indigo-100 text-indigo-600 rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0 mt-1">
                        <FaCheckCircle />
                      </div>
                      <div>
                        <h6 className="font-bold text-gray-800">{item.title}</h6>
                        <p className="text-gray-600 text-sm">{item.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Stats Section */}
              {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { number: "5000+", label: "Active Learners" },
                  { number: "98%", label: "Improved Retention" },
                  { number: "10x", label: "Faster Revision" },
                  { number: "100+", label: "Study Topics" },
                ].map((stat, idx) => (
                  <div key={idx} className="bg-indigo-50 rounded-lg p-3 text-center transition-all duration-300 hover:shadow-md hover:bg-indigo-100">
                    <h3 className="text-xl md:text-2xl font-bold text-indigo-600">{stat.number}</h3>
                    <p className="text-xs md:text-sm text-gray-600">{stat.label}</p>
                  </div>
                ))}
              </div> */}
            </div>
          </div>
        </div>


      </section>
      <Footer />
    </>
  );
};

export default AboutPage;
